import { Controller } from "@hotwired/stimulus"

// Controller for showing progress overlay during long operations
export default class extends Controller {
  static targets = ["overlay", "message"]

  showSolution() {
    this.messageTarget.textContent = "Calculating and validating solution..."
    this.overlayTarget.classList.remove("hidden")
  }

  showSave() {
    this.messageTarget.textContent = "Saving and validating issue..."
    this.overlayTarget.classList.remove("hidden")
  }

  showFindSolutionNew() {
    this.messageTarget.textContent = "Validating, saving and solving the issue..."
    this.overlayTarget.classList.remove("hidden")
  }

  hide() {
    this.overlayTarget.classList.add("hidden")
  }
}
